<!-- Start button (shown when not running and showStartButton is true) -->
@if (!isRunning && showStartButton) {
  <div class="action-section">
    <button mat-raised-button color="primary" (click)="onStartTask()" class="start-button">
      <mat-icon>play_arrow</mat-icon>
      Start Processing
    </button>
  </div>
}

<!-- Cancel button (shown when running) -->
@if (isRunning) {
  <div class="action-section">
    <button mat-stroked-button color="warn" (click)="onCancelTasks()" class="cancel-button">
      <mat-icon>stop</mat-icon>
      Cancel Processing
    </button>
  </div>
}
